export default [{
        path: '/ai-exam',
        name: 'ai-exam',
        component: () =>
            import ("./ai-exam-layout.vue"),
        children: [{
            path: "paper",
            name: "ai-exam-paper",
            meta: {
                needCompany: true,
                needToken: true,
                title: 'AI面试'
            },
            component: () =>
                import ("./ai-paper/list.vue")
        }]
    },
    {
        path: "/ai-exam-paperList/:paperId?",
        name: "ai-exam-paper-list",
        meta: {
            needCompany: true,
            needToken: true,
            detail: '候选人列表'
        },
        component: () =>
            import ("./ai-test/paper-list.vue")
    },
    {
        path: "/ai-paper-info",
        name: "ai-paper-info",
        meta: {
            needCompany: true,
            needToken: true,
        },
        component: () =>
            import ("./ai-paper/paper-info.vue")
    },
    {
        path: "/ai-no-auth",
        name: "ai-no-auth",
        meta: {
            needCompany: true,
            needToken: true,
        },
        component: () =>
            import ("./ai-paper/no-auth.vue")
    },
    // 编辑试卷，预览试卷
    {
        path: "/ai-paper-edit/:paperId?",
        name: "ai-paper-edit",
        meta: {
            needCompany: true,
            needToken: true,
        },
        component: () =>
            import ("./ai-paper/edit.vue")
    },
    {
        path: "/ai-add-question/:paperId?",
        name: "ai-add-question",
        meta: {
            needCompany: true,
            needToken: true,
        },
        component: () =>
            import ("./ai-paper/add-question.vue")
    },
    {
        path: "/ai-review/:connectCode?", // 阅卷
        name: "ai-review",
        meta: {
            needToken: false,
            nocheckUa: true,
            finish: false
        },
        component: () =>
            import ("./ai-paper/review.vue")
    },
    {
        path: "/ai-grade/:paperId?", // 成绩单
        name: "ai-grade",
        meta: {
            needToken: false,
            nocheckUa: true,
            finish: true
        },
        component: () =>
            import ("./ai-paper/review.vue")
    },
    {
        path: "/ai-question-store/:paperId?",
        name: "ai-question-store",
        meta: {
            needCompany: true,
            needToken: true,
        },
        component: () =>
            import ("./ai-paper/question-store.vue")
    },
    {
        path: "/ai-test/wait/:code?",
        name: "ai-test-wait",
        meta: {
            // 答题页和等待页不需要鉴权
            needToken: false,
            nocheckUa: true,
            checkExamUa: false
        },
        component: () =>
            import ("./ai-test/wait.vue")
    },
    {
        path: "/ai-test/exam/:candidateId?",
        name: "ai-test-exam",
        meta: {
            // 答题页和等待页不需要鉴权
            needToken: false,
            checkExamUa: true,
            nocheckUa: true,
        },
        component: () =>
            import ("./ai-test/exam.vue")
    }, {
        path: "/ai-pl-add-exam",
        name: "ai-pl-add-exam",
        meta: {
            needCompany: true,
            needToken: true,
        },
        component: () =>
            import ("./ai-paper/pl-add-exam.vue")
    }, {
        path: "/ai-add-exam-candidate/:paperId",
        name: "ai-add-exam-candidate",
        meta: {
            needCompany: true,
            needToken: true,
        },
        component: () =>
            import ("./ai-test/add-candidate.vue")
    },
]


// WEBPACK FOOTER //
// ./src/content/ai-exam/router.js